/**
 * @fileoverview "Tasks tracker" tab of the project view for the student
 * profile (AR-898): the same tracker as the standalone page, scoped to the
 * project being viewed.
 */

import { useParams } from 'react-router-dom'
import { StudentTrackerContent } from './components'

interface StudentProjectTrackerTabProps {
  projectStatus: string
}

export const StudentProjectTrackerTab = ({ projectStatus }: StudentProjectTrackerTabProps) => {
  const { id: projectId } = useParams()
  return <StudentTrackerContent projectId={projectId ?? ''} projectStatus={projectStatus} />
}
